import { render, staticRenderFns } from "./Top10ScannedPieChart.vue?vue&type=template&id=72d30fd5&scoped=true"
import script from "./Top10ScannedPieChart.vue?vue&type=script&lang=js"
export * from "./Top10ScannedPieChart.vue?vue&type=script&lang=js"
import style0 from "./Top10ScannedPieChart.vue?vue&type=style&index=0&id=72d30fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d30fd5",
  null
  
)

export default component.exports